const ProductFamily = {
  MEMBERSHIP: 'Membership',
  COMMUNITY_PLUS_MEMBERSHIP: 'Community-Plus-Membership',
  VIP_PLANS: 'VIP-Plans',
  GOOGLE_PLAY_STORE: 'google-play-store',
};

export default ProductFamily;
